import { useEffect, useRef, useState } from "react";
import throttle from "lodash.throttle";

const useScrollTabs = (sections, time = 100) => {
  const [activeTab, setActiveTab] = useState(sections[0]);
  const [tabsHeight, setTabsHeight] = useState();
  const tabsRef = useRef();

  useEffect(() => {
    if (tabsRef.current) {
      const { height } = tabsRef.current.getBoundingClientRect();
      setTabsHeight(height);
    }
  }, []);

  useEffect(() => {
    const scrollListener = throttle(() => {
      let activeTab = null;
      let offset = 0;
      if (tabsRef.current) {
        const { top, height } = tabsRef.current.getBoundingClientRect();
        // 5 pixel di margine per considerare l'entrata nella sezione
        offset = top + height + 5;
      }
      // console.log('offset: ', offset);
      sections.forEach((sectionId) => {
        const elem = document.getElementById(sectionId);
        if (!elem) {
          console.warn("Anchor not found: ", sectionId);
          return;
        }
        const targetElem = elem;
        const rect = targetElem.getBoundingClientRect();
        const nextRect = targetElem.nextSibling?.getBoundingClientRect();
        // console.log(`rect.top ${elem.id}: `, rect.top);

        if (rect.top <= 5 || nextRect.top < offset) {
          activeTab = sectionId;
        }
      });
      if (activeTab) {
        setActiveTab(activeTab);
      }
    }, time);
    window.addEventListener("scroll", scrollListener);
    scrollListener();
    return () => window.removeEventListener("scroll", scrollListener);
  }, [sections, time]);

  return [activeTab, tabsRef, tabsHeight];
};

export default useScrollTabs;
